import { render, staticRenderFns } from "./bscdown2.vue?vue&type=template&id=664b4dc1&"
import script from "./bscdown2.vue?vue&type=script&lang=js&"
export * from "./bscdown2.vue?vue&type=script&lang=js&"
import style0 from "./bscdown2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports